import { render } from "./UnexpectedError.vue?vue&type=template&id=912efe20"
import script from "./UnexpectedError.vue?vue&type=script&lang=js"
export * from "./UnexpectedError.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__